export const getProjectId = () =>
  new URLSearchParams(window.location.search).get("projectId");
